<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h4 class="text-info m-1">{{ $t("globals.export_devices") }}:</h4>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            class="float-right m-1"
            @click="exportDevices"
            variant="success"
          >
            {{ $t("globals.download") }}
          </b-btn>
          <b-btn
            class="m-1"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapMutations(["setShowLoadingModal"]),
    exportDevices() {
      const data = {
        query: `
          mutation {
            res: DevicesExport
          }
        `
      };
      this.simpleMutation({data, this_ref: this}).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.close();
    }
  }
};
</script>
